import { ReactComponent as BackIcon } from '@paradigm/icons/src/mailru/navigation/arrow_previous_big.svg';
import { ReactComponent as MoreIcon } from '@paradigm/icons/src/mailru/navigation/more_vertical.svg';
import classNames from 'clsx';
import { ReactComponent as ShapeIcon } from 'img/icons/shape.svg';
import React, { memo, ReactElement, useCallback, useRef } from 'react';
import { getFacesFileId } from 'reactApp/modules/faces/faces.helpers';
import { renderFilterFacesModal } from 'reactApp/ui/Mobile/FilterFacesModal/FilterFacesModal.helpers';

import { FacesTooltip } from './FacesTooltip/FacesTooltip';
import styles from './ViewerToolbar.css';

interface IViewerToolbarProps {
    onClose: (place) => void;
    ext: string;
    subTitle: string;
    nameWithoutExt: string;
    itemId?: string;
    faces?: string[];
    onClickOption: () => void;
}

export const ViewerToolbar = memo<IViewerToolbarProps>(({ onClose, ext, subTitle, nameWithoutExt, itemId = '', faces = [], onClickOption }): ReactElement => {
    const counterText = faces && faces.length <= 9 ? faces.length : '9+';
    const facesButtonsRef = useRef<HTMLDivElement | null>(null);

    const handleClose = useCallback(() => {
        onClose('click');
    }, [onClose]);

    const openFacesModal = useCallback(() => {
        const fileId = getFacesFileId(itemId);
        renderFilterFacesModal({ fileId });
    }, [itemId]);

    return (
        <div className={styles.root}>
            <div className={styles.leftGroup}>
                <div className={classNames(styles.button, styles.button_back)} onClick={handleClose} data-qa-button={'back'}>
                    <BackIcon width={16} height={20} fill="currentColor" />
                </div>
                <div className={styles.info}>
                    <div className={styles.nameBlock}>
                        <div className={styles.name}>{nameWithoutExt}</div>
                        <div>.{ext}</div>
                    </div>
                    <div className={styles.count}>{subTitle}</div>
                </div>
            </div>
            <div className={styles.buttons} ref={facesButtonsRef}>
                {Boolean(faces.length) && (
                    <>
                        <div
                            className={classNames(styles.button, styles.buttonFaces)}
                            onClick={openFacesModal}
                            data-qa-button={'faces'}
                        >
                            <ShapeIcon width={20} height={20} />
                            <div className={styles.facesCount}>{counterText}</div>
                        </div>
                        <FacesTooltip onApply={openFacesModal} targetRef={facesButtonsRef} />
                    </>
                )}
                <div className={styles.button} onClick={onClickOption} data-qa-button={'options'}>
                    <MoreIcon width={20} height={20} fill="currentColor" />
                </div>
            </div>
        </div>
    );
});

ViewerToolbar.displayName = 'ViewerToolbar';
